import React from 'react';

const ContactIcon = ({ className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="75"
      height="75"
      x="0"
      y="0"
      viewBox="0 0 64 64"
    >
      <g transform="matrix(1,0,0,1,0,1.4210854715202004e-14)">
        <g xmlns="http://www.w3.org/2000/svg" id="Send">
          <path
            d="m61.724 8.31a1 1 0 0 0 -1.064-.25l-58 21a1 1 0 0 0 0 1.882l13.47 4.809 3.89 19.449a1 1 0 0 0 .927.8h.053a.992.992 0 0 0 .679-.281c.008-.005 13.142-13.029 13.142-13.029l10.892 3.268a1 1 0 0 0 1.21-.573l15-36a1 1 0 0 0 -.199-1.075zm-8.939 4.728-35.885 20.862-10.945-3.906zm-31.572 37.928-3.092-15.461 32.779-19.057-25.549 21.791a1.845 1.845 0 0 0 -.306.463zm1.944.483 3.5-11.207 5.981 1.794zm22.267-7.666-17.378-5.213 30.329-25.87z"
            fill="#5c48d3"
          />
        </g>
      </g>
    </svg>
  );
};
export default ContactIcon;
